import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Canny API Reference';
const Description =
  "You can use Canny's API to access your data programmatically and integrate Canny with other services.";
const Image = 'https://canny.io/images/canny-social.png';

export default class APIDocsHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://developers.canny.io/api-reference' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
